import { Button, Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { Help } from "../../interfaces/Help";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface HelpDeleteProps {
    help: Help;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function HelpDelete(props: HelpDeleteProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/help/' + props.help._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.help._id);
            })
            .catch(error => {
                navigate('/');
            });
    }

    return(
        <Overlay title={t("Delete help")} onClose={handleClose} className="admin-delete-help-container">
            <Form onSubmit={ handleSubmit }>
                <Form.Text id="deleteConfirmationMessage">
                    { parse(t("You are about to delete help content") + ' ' + '<strong>' + props.help.name + '</strong>. ' +
                        t("This action cannot be undone.") + ' ' +
                        t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
                <div className="actions">
                    <Button variant="primary" type="submit">{ t("Yes") }</Button>
                    <Button variant="secondary" onClick={ handleClose }>{ t("No") }</Button>
                </div>
            </Form>
        </Overlay>
    );
}